import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

// Pixel da conexão da conta com a Meta Ads (Configurações > Integrações). A automação não escolhe
// o pixel: envia sempre para o pixel dessa conexão.
export const useMetaPixel = () => {
  const integrations = useMapGetter('integrations/getAppIntegrations');
  const app = computed(() =>
    integrations.value.find(({ id }) => id === 'meta_ads')
  );
  const connected = computed(
    () => app.value?.connection_status === 'connected'
  );
  const label = computed(() =>
    connected.value ? app.value.connection_label || '' : ''
  );

  return { connected, label };
};
